import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/member1.jpg'
import _imports_1 from '../assets/images/member2.jpg'
import _imports_2 from '../assets/images/member3.jpg'


const _withScopeId = n => (_pushScopeId("data-v-0a08790e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "About" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "about-top" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "about-title" }, "关于我们")
], -1))
const _hoisted_3 = { class: "about-content" }
const _hoisted_4 = { class: "about-content-section" }
const _hoisted_5 = { class: "about-card" }
const _hoisted_6 = { class: "about-card-left card-title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "公司简介", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "about-card-right card-content" }, [
  /*#__PURE__*/_createElementVNode("p", null, "上海秘塔网络科技有限公司成立于2018年4月，是人工智能领域的一家新锐科技公司，致力于用算力换人力，让专业场景的生产力百倍提升。"),
  /*#__PURE__*/_createElementVNode("p", null, "目前，秘塔科技已经拥有上千万用户，总部位于上海市徐汇区“模速空间”，并成立北京和成都两大研发中心。公司在AI搜索、AI写作、法律翻译等方向上开展研发与产品落地。公司基于自身业务特点和技术积累自主研发了大语言模型MetaLLM，该模型于2023年通过《生成式大模型备案》（第二批）、《大模型算法备案》（第二批）。")
], -1))
const _hoisted_9 = { class: "about-content-section" }
const _hoisted_10 = { class: "about-group-profile" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "acs-text" }, "团队简介", -1))
const _hoisted_12 = {
  class: "agp-formers",
  ref: "groupProfile"
}
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"agp-item\" data-v-0a08790e><div class=\"agp-item-avatar\" data-v-0a08790e><img src=\"" + _imports_0 + "\" data-v-0a08790e></div><h3 class=\"agp-item-name\" data-v-0a08790e> 闵可锐</h3><p class=\"agp-item-profile\" data-v-0a08790e> 拥有复旦大学计算机科学学士及英国牛津大学数学系硕士学位，后于美国伊利诺伊大学香槟分校攻读电子与计算机工程博士学位。 曾担任玻森数据CTO&amp;联合创始人、猎豹移动首席科学家、微软亚洲研究院实习研究员，并参与谷歌AdSense基于内容广告建模组点击率预测项目。文本分析及机器视觉研究成果发表于CIKM、CVPR、ACL等相关国际会议和期刊。 </p></div><div class=\"agp-item\" style=\"z-index:1;\" data-v-0a08790e><div class=\"agp-item-avatar\" data-v-0a08790e><img src=\"" + _imports_1 + "\" data-v-0a08790e></div><h3 class=\"agp-item-name\" data-v-0a08790e>王益为</h3><p class=\"agp-item-profile\" data-v-0a08790e>拥有北京大学法学院学士学位，并分别于伦敦大学法学院和哥伦比亚大学法学院获得硕士学位，拥有十年以上国际一线律师事务所法律从业经验，担任北京市创业投资法学研究会理事、北京大学法学院创业企业法律诊所课程导师。</p></div><div class=\"agp-item\" data-v-0a08790e><div class=\"agp-item-avatar\" data-v-0a08790e><img src=\"" + _imports_2 + "\" data-v-0a08790e></div><h3 class=\"agp-item-name\" data-v-0a08790e>唐 悦</h3><p class=\"agp-item-profile\" data-v-0a08790e>因竞赛特招入复旦大学计算机科学与技术专业获得学士学位，曾获NOI2003总决赛银牌，并代表中国参加2004亚洲超级计算机竞赛获得银牌。 拥有极其丰富的工程技术经验，研发过多款成功APP、游戏及工业机械臂等。曾在著名编程竞赛平台TopCoder上取得构架组排名第一。</p></div>", 3)
const _hoisted_16 = [
  _hoisted_13
]
const _hoisted_17 = { class: "about-content-section black-bg" }
const _hoisted_18 = { class: "about-card" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "about-card-left card-content" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "acl-list" }, [
    /*#__PURE__*/_createElementVNode("li", null, "2017 AI Challenger全球AI挑战赛机器翻译冠军"),
    /*#__PURE__*/_createElementVNode("li", null, "2015 NLPCC分词及词性标注冠军"),
    /*#__PURE__*/_createElementVNode("li", null, "2015 Information and Inference Best Paper Prize第二名"),
    /*#__PURE__*/_createElementVNode("li", null, "……")
  ])
], -1))
const _hoisted_20 = { class: "about-card-right card-title" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "研发积累", -1))
const _hoisted_22 = { class: "about-bottom" }
const _hoisted_23 = { class: "wanted" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "wanted-text" }, "招聘岗位", -1))
const _hoisted_25 = { class: "wanted-detail" }
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<div class=\"wanted-detail-card\" data-v-0a08790e><div class=\"wdc-top\" data-v-0a08790e>1</div><h3 class=\"wdc-job-name\" data-v-0a08790e>技术类</h3><p class=\"wdc-job-intro\" data-v-0a08790e>有机会在工作中了解国内外知名企业对智能化产品的需求，参与机器学习/深度学习/模型搭建与产品落地，让自己的技术服务上百万用户</p><div class=\"wdc-bottom\" data-v-0a08790e><a class=\"wdc-btn\" href=\"https://www.zhipin.com/gongsir/61d379287be645371nFz39u8Ew~~.html\" target=\"_blank\" data-v-0a08790e>查看详情</a></div></div><div class=\"wanted-detail-card\" data-v-0a08790e><div class=\"wdc-top\" data-v-0a08790e>2</div><h3 class=\"wdc-job-name\" data-v-0a08790e>运营类</h3><p class=\"wdc-job-intro\" data-v-0a08790e>在B站、小红书等平台寻找适合的KOL/KOC进行产品推广，包括广告投放等工作，提升用户增长</p><div class=\"wdc-bottom\" data-v-0a08790e><a class=\"wdc-btn\" href=\"https://www.zhipin.com/gongsir/61d379287be645371nFz39u8Ew~~.html\" target=\"_blank\" data-v-0a08790e>查看详情</a></div></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReactScrollImage = _resolveComponent("ReactScrollImage")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ReactScrollImage, {
      class: "background-image",
      width: '100%',
      mode: 'scaleX',
      src: require('@/assets/images/bg-7.jpg')
    }, null, 8, ["src"]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_ReactScrollImage, {
              class: "about-card-bg",
              widthOffset: 100,
              mode: 'translateX',
              height: '100%',
              src: require('@/assets/images/bg-8.jpg')
            }, null, 8, ["src"]),
            _hoisted_7
          ]),
          _hoisted_8
        ])
      ]),
      _createElementVNode("section", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, _hoisted_16, 512)
        ])
      ]),
      _createElementVNode("section", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_ReactScrollImage, {
              class: "about-card-bg",
              widthOffset: 100,
              mode: 'translateX',
              height: '100%',
              src: require('@/assets/images/bg-9.jpg')
            }, null, 8, ["src"]),
            _hoisted_21
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createVNode(_component_ReactScrollImage, {
            class: "wanted-detail-bg",
            width: '100%',
            height: '100%',
            src: require('@/assets/images/bg-10.jpg'),
            widthOffset: 100
          }, null, 8, ["src"])
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ]))
}